var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    rx: 61,
    fill: "#FFA826"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_4394)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_329_4394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3271 68.8384C50.6564 68.8384 40.9857 68.8169 31.3149 68.8618C29.9415 68.8618 29.3529 68.5048 29.1351 67.0593C27.8873 58.6089 26.5296 50.1759 25.2131 41.7372C25.0306 40.5667 25.1268 39.4568 26.2824 38.7974C27.3968 38.1674 28.4092 38.4892 29.3941 39.2285C33.4908 42.3029 37.5933 45.3603 41.7018 48.4008C43.7913 49.9614 45.6258 49.6609 47.062 47.5308C50.332 42.693 53.585 37.8461 56.821 32.9902C57.0918 32.5864 57.3507 32.1728 57.6431 31.7846C59.2696 29.6389 61.5023 29.6154 63.07 31.8275C64.7298 34.1684 66.2857 36.5814 67.8867 38.9632C69.8114 41.8308 71.7205 44.7081 73.6609 47.5659C75.0578 49.6258 76.91 49.9438 78.9132 48.4632C82.7921 45.5957 86.6533 42.7028 90.5224 39.8196C90.7559 39.644 91.0011 39.4821 91.2248 39.2949C92.2058 38.4756 93.281 38.1244 94.4523 38.8228C95.6589 39.5446 95.6471 40.7169 95.4568 41.9244C94.9938 44.8492 94.536 47.7753 94.0834 50.7026C93.228 56.1646 92.3314 61.6266 91.5544 67.1062C91.3582 68.4717 90.8167 68.8618 89.4864 68.8618C79.7647 68.8189 70.0449 68.8384 60.3271 68.8384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3466 73.7833C69.967 73.7833 79.5867 73.7833 89.2057 73.7833C91.1285 73.7833 91.1677 73.8379 91.1815 75.7477C90.9853 78.7732 92.3822 83.8002 88.0148 84.1884C69.3012 84.122 50.4757 84.6624 31.7974 83.9757C30.3828 83.6012 29.5529 82.6103 29.5215 81.1199C29.4803 79.179 29.5431 77.2361 29.4822 75.2951C29.4469 74.1461 29.9374 73.7618 31.0518 73.7696C40.8148 73.8126 50.5817 73.7677 60.3466 73.7833Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_4394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.5656,
    height: 96.5656,
    fill: "white",
    transform: "translate(12.0703 12.0703)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_329_4394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.4124,
    height: 54.1634,
    fill: "white",
    transform: "translate(25.1504 30.1719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusYellow);
export default __webpack_public_path__ + "static/media/icon-plus--yellow.e594b01433bc7168309d44a00f067b71.svg";
export { ForwardRef as ReactComponent };